export default __webpack_public_path__ + "static/media/additionalperks.ce6f3f8a.png";